import { TicketPercent } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { cn } from 'src/lib/utils';

type Props = {
  coupon: string;
  className?: string;
};

const Coupon = ({ coupon, className }: Props) => {
  return (
    <div className={cn('flex items-center justify-between gap-2 border-t border-border pt-6', className)}>
      <div className="flex items-center gap-2">
        <TicketPercent aria-label="icon-coupon" className="size-7" />
        <span className="text-lg font-semibold">Coupon</span>
      </div>

      <Badge variant="secondary">{coupon}</Badge>
    </div>
  );
};

export default Coupon;
